import { ReactElement, ReactNode, isValidElement } from 'react';
import { Child, Children, MarkEl } from './types';

export function isMarkNode(node: ReactNode): node is MarkEl {
  return !!(
    node &&
    typeof node === 'object' &&
    (((node as ReactElement).props &&
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (node as ReactElement<any>).props?.['data-testid'] === 'mark') ||
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (node as ReactElement<any>).props?.annotation)
  );
}

export function isElementChild(node: ReactNode): node is ReactElement {
  return !!(
    node &&
    typeof node === 'object' &&
    (node as ReactElement).type &&
    (node as ReactElement).type !== 'mark'
  );
}

export function extractText(node: Child): string {
  if (typeof node === 'string') {
    return node;
  }
  if (!node) {
    return '';
  }

  const children = node.props?.children;

  if (!children) {
    return '';
  }
  if (Array.isArray(children)) {
    return children.map(extractText).join('');
  }

  return extractText(children);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function toChildrenArray(node: ReactElement<any>): Children {
  const raw = Array.isArray(node.props?.children)
    ? node.props.children
    : [node.props?.children];
  const out: Children = [];
  for (const item of raw) {
    if (typeof item === 'string') {
      out.push(item);
    }
    if (isValidElement(item)) {
      out.push(item);
    }
  }
  return out;
}
